/** Every in-app URL, built in one place so routes can be renamed safely. */
export const paths = {
  login: () => '/',
  register: () => '/register',
  users: () => '/dashboard/users',
  reports: () => '/dashboard/reports',
  report: (projectId) => `/dashboard/reports/${encodeURIComponent(projectId)}`,
  projects: () => '/dashboard/projects',
  project: (id) => `/dashboard/projects/${encodeURIComponent(id)}`,
  targetGroup: (projectId, tgId, step = 'basics') =>
    `/dashboard/projects/${encodeURIComponent(projectId)}/target-groups/${encodeURIComponent(tgId)}/${step}`,
};
